package org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager

import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.delete_furniture.DeleteFurnitureModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.DeleteFurnitureRepository

class DeleteFurnitureUseCase(
    private val repository: DeleteFurnitureRepository,
) {
    suspend operator fun invoke(
        furnitureId:String
    ): DeleteFurnitureModel {
        return repository.deleteFloor(
            furnitureId=furnitureId
        )
    }
}